export default __webpack_public_path__ + "static/media/MiViewLogo.594d663b.png";